import { Devices } from "../../../../styles";
import styled from "styled-components";

const Title = styled.h1`
  color: #333333;
  font-weight: normal;
  font-size: 1.25rem;
  @media ${Devices.desktop} {
    font-size: 1.5rem;
  }
`;

export default Title;
